import { render, staticRenderFns } from "./vip-home-yunnan.vue?vue&type=template&id=584bce6c&scoped=true&"
import script from "./vip-home-yunnan.vue?vue&type=script&lang=js&"
export * from "./vip-home-yunnan.vue?vue&type=script&lang=js&"
import style0 from "./vip-home-yunnan.vue?vue&type=style&index=0&id=584bce6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584bce6c",
  null
  
)

export default component.exports